exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".booklanding {\n  text-align: left;\n  padding-bottom: 75px;\n}\n\n.booklanding-top-left {\n  flex: 2 1;\n}\n\n.booklanding-top-left > img {\n  width: 85%;\n}\n\n.booklanding-top-right {\n  flex: 3 1;\n}\n\n.bullet-point {\n  list-style-type: disc;\n  padding-left: 20px;\n}\n", ""]);

// exports
